export function generateSrcSet(url, colCount) {
	if (!url) return '';
	if (!colCount) {
		colCount = 1
	}
	const widths = [180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024];

	const fileTypes = new RegExp(/\.(gif|jpe?g|tiff?|png|webp|avif|bmp)/, 'i');

	return widths.reduce((srcset, width, index) => {
		const fileType = url.match(fileTypes)[0];
		let col

		if (url.includes('no-image-')) return url;

		if (width < 1081) {
			col = 1
		} else {
			col = colCount
		}

		return `${srcset} ${url.replace(fileType, `_${width / col }x${fileType}`)} ${width}w${index < widths.length ? "," : ""}`;
	}, '');
}

export function generateSrc(url, colCount) {
	if (!url) return '';
	if (url.includes('no-image-')) return url;

	const fileTypes = new RegExp(/\.(gif|jpe?g|tiff?|png|webp|avif|bmp)/, 'i');
	const fileType = url.match(fileTypes)[0];

	return url.replace(fileType, `_300x${fileType}`);
}

export function decodeVariantID(variant) {       
	let decoded_variant = atob(variant);
	return decoded_variant.replace('gid://shopify/ProductVariant/', '');
}

export function decodeProductID(product) {       
	let decoded_id = atob(product);
	return decoded_id.replace('gid://shopify/Product/', '');
}

export function formatCurrency(value) {
	return new Intl.NumberFormat(window.locale ?? 'en-GB', { style: 'currency', currency: window.currency ?? 'GBP', minimumFractionDigits: 2}).format(value / (10 ** (window.currencyDecimals ?? 2)))
}


function _parseProductData(dom, handle) {
	const product = dom.querySelector(`[data-product-json][data-product-handle="${handle}"]`);
	const productUrl = dom.querySelector(`[data-product-url][data-product-handle="${handle}"]`);
	
	const productObject = Object.assign({}, JSON.parse(product.innerHTML), {url: JSON.parse(productUrl.innerHTML)})
	
	return { 
		product: productObject
	};
}
function _getProductDataOnPage(handle) {
	try {
		return _parseProductData(document, handle);
	} catch(e) {
		// console.error(`Error parsing product ${handle} data on page`, e);
		return false;
	}
}
async function _getProductDataByAjax(handle) {
	try {
		const parser = new DOMParser();
		const response = await fetch(`/products/${handle}?view=data`);
		const responseText = await response.text();
		const returnedHtml = parser.parseFromString(responseText, 'text/html');
		return _parseProductData(returnedHtml, handle);
	} catch(e) {
		console.error(`Error getting product ${handle} data by ajax`, e);
		return false;
	}
}

export async function getProductData(handle) {
	const data = _getProductDataOnPage(handle) || await _getProductDataByAjax(handle);

	if (!data) {
		console.error(`Cannot get product ${handle} data`);
		return false;
	}
	return data;
}


export function uid() {
	return window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36);
}

export const throttle = (func, limit) => {
    // copied from https://stackoverflow.com/questions/68959654/javascript-throttle-always-returning-function
    let flag = true;
    return function() {
        if(flag) {
            func.apply(this, arguments);
            flag = false;
            setTimeout(() => flag = true, limit);
        }
    }
};